import './TableWidget.scss';
import { ReactElement, ReactNode } from 'react';
import cn from 'classnames';

interface TableWidgetProps {
  twHeaderTopLeft: ReactNode;
  twHeaderTopRight: ReactNode;
  headerBottom?: ReactNode;
  tableComponent: ReactNode;
  twFooter?: ReactNode;
  widgetClassName?: string | Record<string, boolean>;
  headerClassName?: string | Record<string, boolean>;
  bodyClassName?: string | Record<string, boolean>;
}

const TableWidget = ({
  twHeaderTopLeft,
  twHeaderTopRight,
  headerBottom,
  tableComponent,
  twFooter,
  widgetClassName,
  headerClassName,
  bodyClassName
}: TableWidgetProps): ReactElement => (
  <div className={cn('table-widget', widgetClassName)}>
    <div className={cn('tw-header', headerClassName)}>
      <div className='tw-header-top'>
        <div className='tw-header-top-left'>{twHeaderTopLeft}</div>
        <div className='tw-header-top-right'>{twHeaderTopRight}</div>
      </div>
      {headerBottom && <div className='tw-header-bot'>{headerBottom}</div>}
    </div>
    <div className={cn('tw-body', bodyClassName)}>{tableComponent}</div>
    {twFooter && <div className='tw-footer'>{twFooter}</div>}
  </div>
);

export { TableWidget };
